import { debounce } from '@/functions/general.js';

export default {
  data() {
    return {
			debounce: {},
			debounce_t:{},
			d_time:1500,
		};
  },
  methods: {
		debounceM(key, filterFunction,callb,hp){
			if (! this.debounce[key]){
				this.debounce[key] = debounce(()=>{ filterFunction() ;this.debounce[key]=null; (callb && callb())}, this.d_time);
			}
			this.debounce[key](this.debounce_t[key] || 1500);
		},
  }, // methods
};
